export default [
  {
    key: 'title',
    label: 'field.holidayTitle',
    type: 'text',
  },
  {
    key: 'isRepeatEveryYear',
    label: 'field.type',
    type: 'radio',
    options: [
      { text: 'field.applyOnce', value: false },
      { text: 'field.repeatAnnually', value: true },
    ],
    md: 'auto',
    lg: 'auto',
  },
];
